var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { TextInput, DialogHeader, DialogContent, DialogFooter, Alert, Box } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Field } from 'formik';
import { useRenameEntry } from 'app/domains/filesystem';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import { useActiveDocument } from 'shared/domains/documents';
import { CancelButton, FormDialog, SubmitButton } from 'shared/domains/forms';
import { schema } from './schema';
export function RenameDocumentDialog(props) {
    const { onClose } = props;
    const { id, name } = useActiveDocument();
    const [renameEntry, { error }] = useRenameEntry({ type: EntryKind.Document, id });
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () { return renameEntry(values.name).then(onClose); });
    return (<FormDialog size="md" validateOnMount initialValues={{ name }} validationSchema={schema} onSubmit={handleSubmit} onClose={onClose}>
      <DialogHeader title={t({
            message: 'Edit document name',
            comment: 'Rename document dialog: header title',
        })} icon={<Falcon icon="pen-to-square"/>}/>
      <DialogContent>
        <Box flexDirection="column" gap="lg">
          <Field stretch name="name" as={TextInput} label={t({ message: 'Document name', comment: 'Rename document dialog - Document name input label' })} placeholder={t({
            message: 'Document name...',
            comment: 'Rename document dialog - Document name input placeholder',
        })}/>
          {error && (<Alert appearance="danger" title={t({
                message: 'Failed to rename document',
                comment: 'Rename document dialog error alert title',
            })} message={t({
                message: 'Something went wrong, please try again later',
                comment: 'Error alert message',
            })}/>)}
        </Box>
      </DialogContent>
      <DialogFooter>
        <CancelButton size="small" appearance="secondary" onClick={onClose}>
          <Trans>Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small" appearance="primary">
          <Trans>Rename</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
